module.exports = __webpack_public_path__ + "img/a_mostaza.3dd14aaa.svg";